<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <!-- style="height: 50vh" -->
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row">
      <!-- Formulário -->

      <ng-container [ngSwitch]="tabSelecionada">
        <ng-container *ngSwitchCase="EFilaTabsEdit.Filas">
          <app-tab-dados-fila class="w-full" [formFila]="formFila" [companies]="companies">
          </app-tab-dados-fila>
        </ng-container>

        <ng-container *ngSwitchCase="EFilaTabsEdit.Atendentes">
          <app-tab-atendente class="w-full" [dadosPaginacaoAtendentes]="dadosPaginacaoAtendentes"
            [queueAtendentes]="queueAtendentes" (mudouPagina)="mudouPaginaAtendentes($event)" [companyId]="companyId"
            [queuePartnerId]="queuePartnerId" (mudouTamanhoPagina)="mudouTamanhoPaginaAtendentes($event)"
            (recarregarListagem)="carregarAtendentes()">
          </app-tab-atendente>
        </ng-container>

        <ng-container *ngSwitchCase="EFilaTabsEdit.Devices">
          <app-tab-device class="w-full" style="max-width: 800px" [dadosPaginacaoDevices]="dadosPaginacaoDevices"
            [queueDevices]="queueDevices" [companyId]="companyId" (mudouPagina)="mudouPaginaDevices($event)"
            (mudouTamanhoPagina)="mudouTamanhoPaginaDevices($event)" (recarregarListagem)="carregarDevices()">
          </app-tab-device>
        </ng-container>

        <ng-container *ngSwitchCase="EFilaTabsEdit.Motivos">
          <app-tab-reason [companyId]="companyId" class="w-full" style="max-width: 800px"></app-tab-reason>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <p>Aba não encontrada.</p>
        </ng-container>
      </ng-container>

      <!-- Menu Lateral -->
      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto w-1/3"
        style="min-height: 550px">
        <button class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/filas">
          X
        </button>

        <div class="flex gap-y-5 flex-col mt-3">
          <div class="flex flex-col justify-end">
            <button type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== EFilaTabsEdit.Filas }"
              (click)="mudarTabSelecionada(EFilaTabsEdit.Filas)">
              Dados Fila
            </button>
          </div>
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'attendants.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== EFilaTabsEdit.Atendentes }"
              (click)="mudarTabSelecionada(EFilaTabsEdit.Atendentes)">
              Atendentes
            </button>
          </div>
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'device.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== EFilaTabsEdit.Devices }"
              (click)="mudarTabSelecionada(EFilaTabsEdit.Devices)">
              Dispositivos
            </button>
          </div>
          <div class="flex flex-col justify-end ">
            <button *isAllowed="[ERoleAdminString.Admin, 'reason.list']" type="button" class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== EFilaTabsEdit.Motivos }"
              (click)="mudarTabSelecionada(EFilaTabsEdit.Motivos)">
              Motivos
            </button>
          </div>
        </div>
        <hr class="my-4" />
        <div class="flex gap-y-5 flex-col">
          <div class="flex flex-col justify-end">
            <button *isAllowed="[ERoleAdminString.Admin, 'queue.edit']" type="button" class="btn btn--secondary"
              (click)="editarFila()">
              Salvar Fila
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
